var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LkBackLink"},[_c('router-link',{staticClass:"LkBackLink__link",attrs:{"to":_vm.to}},[_c('v-icon',{attrs:{"size":"14px"},domProps:{"textContent":_vm._s('mdi-chevron-double-left')}}),_c('span',[_vm._v("Назад")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }